import actionTypesApi from "../../api/actionTypesApi";

const state = { actionTypes: [] };

const actions = {
    getActionTypes({ commit }) {
        return new Promise((resolve, reject) => {
            actionTypesApi
                .all()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_ACTION_TYPE", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    SET_ACTION_TYPE: (state, actionTypes) => (state.actionTypes = actionTypes),
};
export default { state, actions, mutations };